/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDto } from '../../models/backend-venture-fund-dto';

export interface VentureFundsVentureFundsCopyCreate$Params {
  id: number;
}

export function ventureFundsVentureFundsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDto>;
    }),
  );
}

ventureFundsVentureFundsCopyCreate.PATH = '/api/venture_funds/venture-funds/{id}/copy/';
